import React, { useState } from "react"
import Button from "./generic/buttons/Button"
import { ValueLabel } from "./generic/fields"
import DropdownField from "./generic/form/DropdownField"

export enum ViewMode {
  OVERVIEW = "Overview",
  SEASON = "Season",
  DETAIL = "Detail"
}

export enum FlightMode {
  ARRIVAL = "A",
  DEPARTURE = "D",
  TURNAROUND = "T"
}

interface Props {
  timeOptions: Array<ValueLabel>
  matrix: string
  slotTimeValue: string
  onChangeView?: (viewMode: ViewMode) => void
  onChangeTime?: (viewMode: ViewMode, time: string) => void
}

const FlightAvailability: React.FunctionComponent<Props> = ({
  timeOptions,
  matrix,
  slotTimeValue,
  onChangeView,
  onChangeTime
}) => {
  const [viewMode, setViewMode] = useState(ViewMode.OVERVIEW)

  const viewModes: ViewMode[] = [
    ViewMode.OVERVIEW,
    ViewMode.SEASON,
    ViewMode.DETAIL
  ]

  const handleChangeViewMode = (goBack: boolean) => {
    const currentViewModeIdx = viewModes.findIndex((vm) => vm === viewMode)
    if (currentViewModeIdx >= 0 && currentViewModeIdx <= viewModes.length - 1) {
      const updViewMode =
        viewModes[goBack ? currentViewModeIdx - 1 : currentViewModeIdx + 1]
      setViewMode(updViewMode)
      onChangeView(updViewMode)
    }
  }

  return (
    <div>
      <div className="d-flex justify-content-between">
        {onChangeView && (
          <Button
            onClick={() => handleChangeViewMode(true)}
            icon="chevron_left"
            disabled={viewMode === ViewMode.OVERVIEW}
          />
        )}
        {onChangeTime && (
          <div className="ocs-w-80">
            <DropdownField
              options={timeOptions}
              value={slotTimeValue}
              clearable={false}
              onChange={(name, value, isValid) => {
                onChangeTime(viewMode, value)
              }}
            />
          </div>
        )}
        {onChangeView && (
          <Button
            onClick={() => handleChangeViewMode(false)}
            icon="chevron_right"
            disabled={viewMode === ViewMode.DETAIL}
          />
        )}
      </div>
      <div
        className="overflow ocs-slot-availability-matrix"
        dangerouslySetInnerHTML={{ __html: matrix }}
      />
    </div>
  )
}

export default FlightAvailability

